<template>
  <div class="container-fluid mt-3">
    <div class="user">
      <div class="row p-3">
        <div class="col col-sm-10">
          <h3>User List</h3>
        </div>

        <div class="col col-sm-2">
          <button
            type="button"
            class="btn btn-outline-success "
            data-toggle="modal"
            data-target="#createUserModal"
          >
            ADD NEW
          </button>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-6">
              <form
                @submit="searchUsers"
                class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
              >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control bg-light border-right-secondary "
                    placeholder="Search for..."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    data-toggle="popover"
                    data-trigger="hover"
                    title="SEARCH"
                    v-model="userSearchValue"
                    data-content="Search Users Here"
                  >

                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="submit"
                    >
                      <i class="fas fa-search fa-sm" />
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-6">
              <div class="row">
                <div class="col-md-5">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label
                        class="input-group-text bg-secondary text-light"
                        v-if="userStatus === 'all'"
                        for="inputUserStatus"
                      >Status</label>


                      <label
                        class="input-group-text bg-success text-light"
                        v-if="userStatus === 'active'"
                        for="inputUserStatus"
                      >Status</label>

                      <label
                        class="input-group-text bg-danger text-light"
                        v-if="userStatus === 'inactive'"
                        for="inputUserStatus"
                      >Status</label>

                      <!--<label class="input-group-text bg-secondary text-light"-->
                      <!--v-else-if="userStatus == 'all'"-->
                      <!--for="inputUserStatus">Status</label>-->
                    </div>
                    <select
                      class="custom-select"
                      @change="setKey"
                      v-model="userStatus"
                      id="inputUserStatus"
                    >
                      <option
                        value="all"
                        class="text-secondary"
                      >
                        All
                      </option>
                      <option
                        value="active"
                        class="text-success"
                      >
                        active
                      </option>
                      <option
                        value="inactive"
                        class="text-danger"
                      >
                        inactive
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="table-header">
                <tr>
                  <th
                    scope="col"
                    width="20px;"
                    class="p-1"
                  >
                    #
                  </th>
                  <th
                    scope="col"
                    width="30px;"
                    class="p-1"
                  >
                    ID
                  </th>
                  <th
                    scope="col"
                    width="200px;"
                    class="p-1"
                  >
                    NAME
                  </th>
                  <th
                    scope="col"
                    width="80px;"
                    class="p-1"
                  >
                    USERTYPE
                  </th>
                  <th
                    scope="col"
                    width="100px;"
                    class="p-1"
                  >
                    EMAIL
                  </th>
                  <th
                    scope="col"
                    width="100px;"
                    class="p-1"
                  >
                    USERNAME
                  </th>
                  <th
                    scope="col"
                    width="200px;"
                    class="p-1"
                  >
                    ADDRESS
                  </th>
                  <th
                    scope="col"
                    width="50px;"
                    class="p-1"
                  >
                    STATUS
                  </th>
                  <th
                    scope="col"
                    width="150px;"
                    style="text-align: center;"
                    class="p-1"
                  >
                    ACTIONS
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(user,index) in users.data"
                  :key="users.data.id"
                  :class="{'inactive': !user.status}"
                >
                  <th
                    scope="row"
                    class="p-1"
                  >
                    {{ ((current_page-1) * per_page) + (index + 1) }}
                  </th>
                  <td class="p-1">
                    <span>{{ user.employee_id }}</span>
                  </td>

                  <td
                    style="text-align: left;"
                    class="p-1"
                  >
                    <small>{{ user.last_name+' '+user.name+' '+user.middle_name }}</small>
                  </td>

                  <td class="p-1">
                    <span v-if="user.user_type">{{ user.user_type.name }}</span>
                  </td>

                  <td class="p-1">
                    <small>{{ user.email }}</small>
                  </td>

                  <td class="p-1">
                    <span>{{ user.username }}</span>
                  </td>

                  <td class="p-1">
                    <small>{{ user.address }}</small>
                  </td>

                  <td class="p-1">
                    <span
                      v-if="user.status == 1"
                      class="text-success"
                    >ACTIVE</span>
                    <span
                      v-else-if="user.status !== 1"
                      class="text-danger"
                    >INACTIVE</span>
                  </td>

                  <td class="p-1">
                    <!-- Button trigger modal -->
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm font-weight-bold action"
                      data-toggle="modal"
                      data-target="#principalModal"
                      @click="showUser(user.id)"
                    >
                      <i class="fa fa-eye" />
                      view
                    </button>
                                        &nbsp;
                    <button
                      class="btn btn-outline-danger btn-sm font-weight-bold action"
                      @click="removeUser(user.id)"
                    >
                      <i
                        class="fa fa-trash-alt"
                        title="delete"
                      />
                      delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-footer">
          <pagination
            :data="users"
            @pagination-change-page="getResults"
          >
            <span slot="prev-nav"><i class="fa fa-angle-double-left" />Previous</span>
            <span slot="next-nav">Next <i class="fa fa-angle-double-right" /></span>
          </pagination>
        </div>
      </div>

      <!-- End of Topbar -->

      <create-user />
    </div>
  </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import CreateUser from './CreateUser';
    import $ from 'jquery';
    import {formMixins} from '../../../mixins/formMixins';

    export default {
        mixins: [formMixins],
        name: 'IndexUser',
        components:{
            'create-user': CreateUser
        },
        data() {
            return{
                userTypeName : null,
                userSearchValue: '',
                userStatus: 'all'
            }
        },
        methods: {
            ...mapActions(['getAllUser','deleteUser','getUserPaginated']),
            showUser(id) {
                this.$router.push(`/user/${id}`).catch(()=>{});
            },
            async removeUser(id){
                if(await this.deleteAlert('Are you sure you want to remove this record')) {
                    this.deleteUser(id);
                }
            },
            searchUsers(e){
                e.preventDefault();
                let page = page = 1;
                let searchValue = this.userSearchValue;
                let paramStatus = this.userStatus;
                this.getResults(page,searchValue,paramStatus);
            },
            async getResults(page = 1,searchValue = this.userSearchValue,paramStatus = this.userStatus) {
                this.getUserPaginated({page,searchValue,paramStatus});
            },
            setKey(e) {
                this.userStatus = e.target.value;
            }
        },

        computed: {
            ...mapGetters(['user','users','current_page','per_page']),
        },
        created() {
            let page = page = 1;
            let searchValue = this.userSearchValue;
            let paramStatus = this.userStatus;
            this.getUserPaginated({page,searchValue,paramStatus});
        },

        mounted:function() {
            $(document).ready(function(){
                $('[data-toggle="popover"]').popover();
            });
        }
    };
</script>

<style scoped>

    .action{
        font-size: 0.8em;
    }

    .table-responsive tr{
        text-align: left;
    }


    .user{
        height: 500px;
    }
</style>
